/**
 * Ищем контейнер
 * @param target
 * @returns {*}
 */
function findContainer(target) {
	if (!target) return false;
	return document.querySelector(target)
}

/**
 * Вытаскиваем все дата атрибуты у элемента
 * @param node
 * @returns {{}}
 */
function getDataAttributes(node) {
	if (!node) return false;

	let obj = {},
		arr = [].filter.call(node.attributes, function (at) {
			return /^data-/.test(at.name);
		});

	if (arr.length) {
		arr.forEach(function (v) {
			obj[v.name] = v.value
		});
	}

	return obj;
}

export {findContainer, getDataAttributes}